var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableActionEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14287 17.4858L0.714294 19.2858L2.51429 12.8572L14.2857 1.14296C14.4187 1.00689 14.5777 0.898778 14.753 0.824968C14.9284 0.751156 15.1169 0.713135 15.3072 0.713135C15.4974 0.713135 15.6859 0.751156 15.8613 0.824968C16.0366 0.898778 16.1956 1.00689 16.3286 1.14296L18.8572 3.68581C18.991 3.81861 19.0973 3.97663 19.1699 4.1507C19.2424 4.32478 19.2797 4.51151 19.2797 4.7001C19.2797 4.88868 19.2424 5.07541 19.1699 5.2495C19.0973 5.42358 18.991 5.58158 18.8572 5.71438L7.14287 17.4858Z",
    stroke: "#AA1A5F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActionEdit);
export default __webpack_public_path__ + "static/media/table-action-edit.2740fc0f3e729a6389b22f9c05007ee9.svg";
export { ForwardRef as ReactComponent };